import { render, staticRenderFns } from "./MEDIA_LOADER.vue?vue&type=template&id=71241ed2&scoped=true&"
import script from "./MEDIA_LOADER.vue?vue&type=script&lang=js&"
export * from "./MEDIA_LOADER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71241ed2",
  null
  
)

export default component.exports